import { Tooltip } from "client/components/core/tooltip";
import React from "react";
import { useTranslation } from "react-i18next";

interface ToggleProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "type" | "onChange"
  > {
  label?: React.ReactNode;
  skipTranslation?: boolean;
  tooltipText?: string;
  skipTranslationTooltip?: boolean;
  wrapperClassName?: string;
  onChange: (checked: boolean) => void;
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  skipTranslation,
  tooltipText,
  skipTranslationTooltip,
  wrapperClassName = "",
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <span
      id={props.id}
      className={`flex items-center gap-2 ${wrapperClassName}`}
    >
    <label className="relative flex items-center cursor-pointer gap-2 rounded-l-full">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={`
          appearance-none cursor-pointer rounded-full
          w-8 h-[19px] flex items-center transition-colors duration-200
          ${checked ? "bg-primary-500" : "bg-bgTertiary"}
          disabled:bg-btnDisabled focus:outline-none
        `}
        {...props}
      />
      <span
        className={`
          absolute top-1 left-1
          w-[11px] h-[11px] bg-bgPrimaryBase rounded-full transform transition-transform duration-200
          ${checked ? "translate-x-[13px]" : "translate-x-0"}
        `}
      />
      {label && (
        <span className="text-M">
          {!skipTranslation && typeof label === "string" ? t(label) : label}
        </span>
      )}
    </label>
    {tooltipText && (
      <Tooltip message={tooltipText} skipTranslation={skipTranslationTooltip} />
    )}
    </span>
  );
};
